import { useEffect } from "react"
import { useLocation } from "react-router-dom"

/**
 * Custom hook that scrolls to top when the route changes
 * This ensures that when users navigate between pages, they start at the top
 */
export const useScrollToTop = (): void => {
  const { pathname } = useLocation()

  useEffect(() => {
    // Scroll to top when pathname changes
    try {
      // Try smooth scrolling first (modern browsers)
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      })
    } catch (error) {
      console.error("Error scrolling to top: Feature not supported", error)
      // Fallback for browsers that don't support smooth scrolling
      window.scrollTo(0, 0)
    }
  }, [pathname])
}
